import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const GEO_REDIRECT_KEY = 'geo_redirect_done';

export function useGeoRedirect() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Kullanıcı daha önce manuel dil seçtiyse veya redirect yapıldıysa tekrar yapma
    if (sessionStorage.getItem(GEO_REDIRECT_KEY)) return;

    // Eğer kullanıcı zaten /tr ile başlayan bir sayfadaysa Türkçe seçmiş demektir
    if (location.pathname.startsWith('/tr')) {
      sessionStorage.setItem(GEO_REDIRECT_KEY, 'done');
      return;
    }

    // IP tabanlı ülke tespiti
    fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(4000) })
      .then((res) => res.json())
      .then((data) => {
        sessionStorage.setItem(GEO_REDIRECT_KEY, 'done');
        if (data?.country_code === 'TR') {
          // Türkiye'den bağlanıyorsa /tr'ye yönlendir.
          // Sorgu dizesi ve hash korunur ki Google Ads gclid'i ve UTM
          // parametreleri yönlendirmede kaybolmasın (dönüşüm atıfı için kritik).
          const trBase = location.pathname === '/' ? '/tr' : `/tr${location.pathname}`;
          navigate(`${trBase}${location.search}${location.hash}`, { replace: true });
        }
        // Diğer ülkeler için bir şey yapma, İngilizce kalır
      })
      .catch(() => {
        // API başarısız olursa sessizce geç, İngilizce kalır
        sessionStorage.setItem(GEO_REDIRECT_KEY, 'done');
      });
  }, []);
}
